module.exports = __webpack_public_path__ + "static/yachtsafe-extraimg3@2x-min-0215bed64b0da67a6d3e7a24a504ec55.png";